use App\Models\Offer;
<template>
    <modal @close="$emit('close')" maxWidth="480px" width="98%">
        <div slot="title">{{$t('title')}}</div>
        <div slot="footer" class="py-2 px-3 d-flex">
            <div class="flex-grow-1 text-right">
                <button class="btn btn-sm btn-primary" @click="useCoupon" :disabled="!selectedCoupon">{{$t('use')}}</button>
            </div>
        </div>
        <div class="container">
            <loading-indicator :clear-background="true" :full-parent="true" :is-loading="isLoading"></loading-indicator>
            <div>
                <table v-if="coupons.length && isCouponTotalLoaded" class="ding-table w-100">
                    <tbody>
                        <tr v-for="c in coupons" :key="c.id"
                            class="coupon-tr cursor-pointer"
                            @click.stop.prevent="toggleSelectedCoupon(c)"
                            :class="{selected: selectedCoupon && selectedCoupon.id == c.id}"
                        >
                            <td class="coupon-item-brief" :style="{background: provider.theme_tint_hex}">
                                {{  getCouponBrief(c) }}
                            </td>
                            <td class="coupon-item-content">
                                <div class="coupon-item-title">
                                    {{  getCouponDisplayText(c) }}
                                </div>
                                <div>
                                    <div class="text-muted pt-0">
                                        <small>{{ formatDate(c.offer.start, c.expired_at) }}</small>
                                    </div>
                                    <div class="text-muted pt-0">
                                        <small>{{ getCouponMinOrderAmountCondition(c) }}</small>
                                    </div>
                                    <div v-if="hasLimitItemConditions(c)">
                                        <small><a class="limit-items-link" @click="showLimitItems(c.offer)">{{ $t('limit_to_certain_items') }}</a></small>
                                    </div>
                                </div>
                                <div style="white-space:pre-line;">{{ c.offer.description }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center text-muted py-3">
                    {{ $t('no_available_coupon') }}
                </div>
            </div>
        </div>
        <modal v-if="limitedItemsContent" @close="limitedItemsContent = null" width="95%" max-width="480px">
            <div slot="title">{{$t('limited_items_title')}}</div>
            <div class="px-4 py-4">
                <div v-html="limitedItemsContent"></div>
            </div>
        </modal>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventApplyOffer } from '../bu/models/GA4';
import Modal from './common/Modal.vue';
import promptConfirm from '../mixins/prompt-confirm';
import api from '../mixins/api';
import Chip from './common/Chip.vue';
import LoadingIndicator from './common/LoadingIndicator.vue';
import moment from 'moment';
import { getExchangedAmount } from '../bu/CurrencyUtils';

export default {
    components: { Modal, Chip, LoadingIndicator },
    props: ['context', 'provider', 'customer'],
    mixins: [promptConfirm, api],
    data() {
        return {
            coupons: [],
            coupons: [],
            selectedCoupon: null,
            offerDiscountMap: {},
            isLoading: false,
            isCouponTotalLoaded: false,
            limitedItemsContent: null
        }
    },
    async mounted() {
        this.isLoading = true;
        this.getAvailableCustomerCoupons((response, error) => {
            this.isLoading = false;
            if (error) {
                this.promptAlert(error);
            } else {
                this.coupons = response.data;
            }
        })
    },
    computed: {
        ...mapGetters({
            cartItems: 'cart/items',
            itemTotal: 'cart/itemTotal',
            bookingPassTotal: 'cart/bookingPassTotal',
            serviceTotal: 'cart/serviceTotal',
            currency: 'currencies/currency',
            currencyRateMap: 'currencies/currencyRateMap',
            currencyOptions: 'currencies/currencyOptions',
        }),
        nonEmptyCartItems() {
            return this.cartItems.filter((item) => item.count > 0);
        }
    },
    watch: {
        coupons() {
            this.getAllCouponDiscounts(this.cartItems);
        }
    },
    methods: {
        ...mapActions({
            setOffer: 'cart/setOffer'
        }),
        showLimitItems(coupon) {
            this.getOfferLimitItems(coupon.id, (response, error) => {
                let messages = [];
                const result = response.data;
                if (result.services.length > 0) {
                    messages.push(this.$t('limited_services', {services: result.services.join(', ')}));
                }
                if (result.items.length > 0) {
                    messages.push(this.$t('limited_items', {items: result.items.join(', ')}));
                }
                this.limitedItemsContent = messages.join('<br>');
            });
        },
        getCouponBrief(coupon) {
            if (coupon.offer.rule_type === 'FIXED_AMOUNT') {
                return this.$t('coupon_type_fixed_amount', { amount: this.getExchangedAmount(-coupon.offer.value) })
            } else if (coupon.offer.rule_type === 'PERCENTAGE') {
                if (this.$i18n.locale.indexOf('en') == 0) {
                    return this.$t('coupon_type_percent_off_en', {offPercentage: coupon.offer.value})
                } else {
                    var zhe = 100 - coupon.offer.value;
                    if (zhe % 10 === 0) {
                        zhe = zhe / 10;
                    }
                    return this.$t('coupon_type_percent_off_zh', {zhe})
                }
            }
            return 1234;
        },
        getCouponMinOrderAmountCondition(coupon) {
            const minOrderAmountCondition = coupon.offer?.conditions.map(c => {
                let dup = Object.assign({}, c);
                if (c.extras && typeof c.extras == 'string') {
                    dup.extras = JSON.parse(c.extras);
                }
                return dup;
            }).find((c) => c.type === 'MIN_ORDER_AMOUNT');

            if (minOrderAmountCondition) {
                return this.$t('min_order_amount_required', { amount:  this.getExchangedAmount(minOrderAmountCondition.extras.min) });
            }
            return null;
        },
        getCouponLimitItemNames(coupon) {
            const limitedItems = conditions.find(c => c.type == 'LIMITED_ITEMS');
            if (limitedItems) {
                if (limitedItems.extras.service_ids && limitedItems.extras.service_ids.length) {
                    const matched = limitedItems.extras.service_ids.find(id => id == this.context.selectedService.id);
                    if (!matched) {
                        cb();
                    }
                }
                this.nonEmptyCartItems.forEach(item => {
                    if (item.itemId && limitedItems.extras.buyables && limitedItems.extras.buyables.length) {
                        const matched = limitedItems.extras.buyables.find(buyable => buyable.item_id == item.itemId && buyable.spec_id == item.specId);
                        if (!matched) {
                            cb();
                        }
                    }
                })
            }
        },
        hasLimitItemConditions(coupon) {
            return coupon.offer?.conditions.filter((c) => c.type === 'LIMITED_ITEMS').length > 0;
        },
        formatDate(start, end) {
            if (start && end) {
                return this.$t('expired_at') + moment.tz(start, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD') + '~' + moment.tz(end, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD');
            } else if (end) {
                return "!~" + this.$t('expired_at') + moment.tz(end, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD');
            } else {
                return this.$t('no_expired_date');
            }
        },
        getCouponDisplayText(coupon) {
            if (coupon && this.isCouponTotalLoaded) {
                return coupon.offer.title;
            } else {
                return '';
            }
        },
        getAllCouponDiscounts() {
            const dateFormatStyle = 'YYYY-MM-DD HH:mm:ss';
            const start = this.context.selectedDate ? moment.tz(this.context.selectedDate, this.provider.timezone).format(dateFormatStyle) : null;
            const end = this.context.selectedEndDate ? moment.tz(this.context.selectedEndDate, this.provider.timezone).format(dateFormatStyle) : null;
            const levelId = this.customer?.level?.id;
            const serviceId = this.context.selectedService?.id;

            this.coupons.map(coupon => coupon.offer).forEach(offer => {
                this.isLoading = true;
                this.getOfferDiscountAmount(this.nonEmptyCartItems, start, end, levelId, serviceId, offer, (response, error) => {
                    this.isCouponTotalLoaded = true;
                    this.isLoading = false;
                    if (response?.data && Array.isArray(response.data)) {
                        const data = response.data.find(item => item.offer_type === 'App\\Models\\Offer' && item.offer_id === offer.id);
                        if (data) {
                            this.$set(this.offerDiscountMap, offer.id, data.discount_amount);
                        }
                    } else if (error) {
                        this.$set(this.offerDiscountMap, offer.id, '--');
                        const message = error.response?.data?.error;
                        if (error.response.status !== 422 && message) {
                            this.promptAlert(message);
                        }
                    }
                });
            })
        },
        toggleSelectedCoupon(coupon) {
            if (coupon) {
                if (this.selectedCoupon && this.selectedCoupon.id == coupon.id) {
                    this.selectedCoupon = null;
                } else {
                    this.selectedCoupon = coupon;
                }
            }
        },
        isCouponValid() {
            const cb = () => {
                this.promptAlert(this.$t('coupon_condition_not_met', {title: this.selectedCoupon.offer.title}));
                this.selectedCoupon = null;
                return false;
            }
            const conditions = this.selectedCoupon?.offer?.conditions.map(c => {
                if (c.extras && typeof c.extras == 'string') {
                    c.extras = JSON.parse(c.extras);
                }
                return c;
            });

            const minOrderAmountCondition = conditions.find(c => c.type == 'MIN_ORDER_AMOUNT');
            if (minOrderAmountCondition) {
                if ((this.bookingPassTotal + this.itemTotal + this.serviceTotal) < minOrderAmountCondition.extras.min) {
                    cb();
                }
            }

            const limitedItems = conditions.find(c => c.type == 'LIMITED_ITEMS');
            if (limitedItems) {
                if (limitedItems.extras.service_ids && limitedItems.extras.service_ids.length) {
                    const matched = limitedItems.extras.service_ids.find(id => id == this.context.selectedService.id);
                    if (!matched) {
                        cb();
                    }
                }
                this.nonEmptyCartItems.forEach(item => {
                    if (item.itemId && limitedItems.extras.buyables && limitedItems.extras.buyables.length) {
                        const matched = limitedItems.extras.buyables.find(buyable => buyable.item_id == item.itemId && buyable.spec_id == item.specId);
                        if (!matched) {
                            cb();
                        }
                    }
                })
            }
            return true;
        },
        async useCoupon() {
            if (!this.isCouponValid()) {
                return;
            };
            if (this.selectedCoupon) {
                const offer = this.selectedCoupon.offer;
                const discount = this.offerDiscountMap[offer.id];
                offer.discount = discount;
                this.setOffer({offer, customerOfferId: this.selectedCoupon.id});
                this.promptAlert(
                    this.$t('success_use_coupon', {
                        couponTitle: offer.title,
                        value: this.getExchangedAmount(discount)
                    }),
                    null,
                    'success'
                )
                this.trackApplyOffer(offer, discount, true);
                this.$emit('close');
            }
        },
        trackApplyOffer(offer, discount, isSuccess) {
            window.tracker.track(() => new EventApplyOffer(offer, discount, isSuccess));
        },
        getExchangedAmount(amount) {
            return getExchangedAmount({
                rateMap: this.currencyRateMap,
                amount,
                from: this.provider.currency || 'TWD',
                to: this.currency,
                currencyOptions: this.currencyOptions,
            });
        },
    }
}
</script>

<style scoped lang="scss">

.limit-items-link {
    color: var(--blue);
}

.container {
    background: #F2F2F2;
}

.coupon-item {
    width: fit-content;
}

.coupon-item-title {
    font-size: 1.15em;
}

.coupon-item-brief {
    color:white;
    width: 120px;
    font-size: larger;
    font-weight: bold;;
    text-align: center;
}

.coupon-tr {
    td {
        border: transparent 1px solid;
    }
    td:nth-child(1) {
        border-right: 0;
    }
    td:nth-child(2) {
        border-left: 0;
    }
}

.coupon-tr:hover {
    td {
        border: #bbb 1px solid;
        background: #Fafafa;
    }
    td:nth-child(1) {
        border-right: 0;
    }
    td:nth-child(2) {
        border-left: 0;
    }
}

.coupon-tr.selected {
    td {
        border: #AAA 1px solid;
        background: #Fafafa;
    }
    td:nth-child(1) {
        border-right: 0;
    }
    td:nth-child(2) {
        border-left: 0;
    }
}
</style>

<i18n>
    {
        "en": {
            "title": "Coupon",
            "use": "Use",
            "select_coupon": "Select coupon",
            "success_use_coupon": "{couponTitle} is used and will get {value} discount",
            "no_available_coupon": "No available coupon",
            "coupon_condition_not_met": "Coupon {title} condition not met, please check terms.",
            "expired_at": "Expired at ",
            "no_expired_date": "Permanent",
            "coupon_type_fixed_amount": "{amount}",
            "coupon_type_percent_off_en": "{offPercentage} OFF",
            "min_order_amount_required": "Applicable when order more than {amount}",
            "limit_to_certain_items": "Applicable with limited items/services only",
            "limited_services": "Applicable services: {services}",
            "limited_items": "Applicable items: {items}",
            "limited_items_title": "Applicable Items"
        },
        "zh": {
            "title": "優惠券",
            "use": "使用",
            "select_coupon": "選取優惠券",
            "success_use_coupon": "將使用優惠券 {couponTitle}，\n折扣 {value} 至本次消費",
            "no_available_coupon": "沒有可以使用的優惠券",
            "coupon_condition_not_met": "優惠券 {title} 條件不滿足，無法使用",
            "expired_at": "使用期限 ",
            "no_expired_date": "永久有效",
            "coupon_type_fixed_amount": "折抵 {amount}",
            "coupon_type_percent_off_zh": "{zhe} 折",
            "min_order_amount_required": "消費滿 {amount} 可使用",
            "limit_to_certain_items": "部分商品/服務適用",
            "limited_services": "<h6>可折扣服務</h6><div>{services}</div>",
            "limited_items": "<h6>可折扣商品</h6><div>{items}</div>",
            "limited_items_title": "可折扣項目"
        }
    }
</i18n>